import React, { useEffect, useState } from "react";

//Importar helpers.
import { filterChatsOldest } from "../../../../helpers/array";
import { FILTER_VALUE_ACTIVOS, FILTER_VALUE_FINALIZADOS, FILTER_VALUE_MIS_CHATS } from "../../../../const/filtersValue/filterValue";
import SocketEventHandlerComponent from "../../../SocketEventHandler";

//Importar componentes locales.
import ChatInInbox from "./ChatInInbox";
import BtnGetMoreChats from "../../../common/Buttons/BtnGetMoreChats";

//Importar íconos de Material UI.
import { SmsFailed } from '@mui/icons-material/';
import useGetChatInInbox from "../../../../hooks/useGetChatInInbox";
import { disconnectSocket } from "../../../../config/socket";

// ListChats: Componente que renderiza la lista de Chats disponibles dentro del Inbox.

const ListChats = ({ 
    chatsArray,
    setChatsArray,
    onChangeChat,
    setPeticionChatsSuccess,
    filterValue,
    setLoading,
    loading,
    searching,
    searchChatFinish,
    setChatsOriginal, 
    chatsOriginal
}) => {

    const [idChatSeleccionado, setIdChatSeleccionado] = useState(null); //Estado para actualizar el id del chat seleccionado.

    const onSelectedChat = (chatSelected, idChat) => { //LLamar a la función de callback dentro de Chats.jsx.
        let chat = chatsArray.filter(chat => chat.IdChat === idChat); //Buscar en el array con los chats, un chat que tenga el id seleccionado.
        //Función callback que recibe los datos del chat seleccionado dentro de ChatInInbox.jsx para actualizar un estado dentro de Chats.jsx
        if (chat) onChangeChat(chatSelected, chat);
        setIdChatSeleccionado(idChat); //Actualizar el id del chat Seleccionado.
    };

    useEffect(() => { //Se ejecuta para aplicar o no el filtro para ordenar los chats ascendetemente, dependiendo de si es finalizado o activo.
        //Si el filtro es de mis chats o activos, ordenar los chats de forma ascendete.
        if (filterValue === FILTER_VALUE_ACTIVOS || filterValue === FILTER_VALUE_MIS_CHATS){ 
            setChatsArray(filterChatsOldest(chatsArray));
            setChatsOriginal(filterChatsOldest(chatsOriginal));
        }
        else setChatsArray(chatsArray);
    }, [filterValue, chatsArray, chatsOriginal]);

    useGetChatInInbox({ setChatsArray, setChatsOriginal, setPeticionChatsSuccess, setLoading }); //Traer la lista de chats dentro del Inbox.

    return (
        <div className="container-inbox__list-chat">
            {/* Renderiza el componente SocketEventHandlerComponent */}
            <SocketEventHandlerComponent filterValue={filterValue}  setChatsArray={setChatsArray}
              chatsArray={chatsArray} searching={searching} chatsOriginal={chatsOriginal} 
              setChatsOriginal={setChatsOriginal}/>

            {/*Boton para desconectar el socket manualente para los tests */}
            {/* <button onClick={() => disconnectSocket()}>Desconectar Socket</button> */}
            
            {/*------------Renderiza los chats disponibles en el Inbox----------- */}
            {!loading && chatsArray.map(chat => (
                <ChatInInbox key={chat.IdChat} chat={chat} idChat={chat.IdChat} filterValue={filterValue}
                    onSelectedChat={onSelectedChat} idChatSeleccionado={idChatSeleccionado} />
            ))}

            {/*------------Renderiza por si no hay elementos en la lista de chats del Inbox----------- */}
            {!loading && chatsArray.length === 0 && <div className="content-unselectedChat--text">
                <SmsFailed sx={{ fontSize: "90px", color: "#96989A" }} />
                <span>No se encontraron Chats Disponibles</span>
            </div>}

            {!loading && chatsArray.length > 5 && filterValue === FILTER_VALUE_FINALIZADOS &&
                <BtnGetMoreChats setChats={chatsArray} chats={chatsArray} searchChatFinish={searchChatFinish}/>
            }

        </div>
    )
};

export default ListChats;